import { useTranslations } from "contexts/LocalizationContext";
import { Button } from "@chakra-ui/react";
import { trackCustomEvent } from "utils/tracking";
import config from "config/config";
import type { LogInButtonProps } from "./types";

const LOGIN_BUTTON_EVENT = { event: "login_click", placement: "top_menu" } as const;

export const LogInButton = ({ labelKey = "button_login", ...props }: LogInButtonProps) => {
  const translations = useTranslations();

  const handletrackEvents = () => trackCustomEvent(LOGIN_BUTTON_EVENT);

  return (
    <Button
      key="button_login"
      variant="primary"
      href={`${config.webappUrl}/plus`}
      onClick={handletrackEvents}
      ml={{ lg: 1, xl: 8 }}
      px={{ lg: 3, xl: 6 }}
      title={translations("button_login")}
      as="a"
      _visited={{}}
      data-testid="top-navbar-login-airhelp-plus"
      textAlign="center"
      width={{ base: "full", lg: "initial" }}
      {...props}
    >
      {translations(labelKey)}
    </Button>
  );
};
